import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3e878aca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "kt_aside",
  class: "notion-sidebar"
}
const _hoisted_2 = {
  class: "notion-sidebar-brand",
  id: "kt_aside_logo"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "/media/betcomrade-logo.svg",
  class: "notion-logo"
}, null, -1))
const _hoisted_4 = { class: "notion-sidebar-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_KTMenu = _resolveComponent("KTMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "notion-logo-link"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_KTMenu)
    ])
  ]))
}